export default function clearProps(props) {
  const dirtyProps = [
    'lg',
    'md',
    'sm',
    'horizontal',
    'highlight',
    'scroll',
    'body',
    'secondary',
    'primary',
    'proportion-3-2',
    'global',
    'block',
    'xxl',
    'proportion-1-1',
    'proportion-3-4',
    'proportion-1-2',
    'text',
    'email',
    'cep',
    'cpf',
    'cnpj',
    'cpf-cnpj',
    'phone',
    'email',
    'number',
    'password',
    'search',
    'textarea',
    'rate',
    'select',
    'action',
    'date',
    'phone-mobile',
    'phone-fixed',
    'image',
    'icon'
  ]

  const cleanedProps = {}
  for (let i = 0, lgt = dirtyProps.length; i < lgt; i++) {
    cleanedProps[dirtyProps[i]] = undefined
  }
  return Object.assign({}, props, cleanedProps)
}
